import { Loader, Modal, Stack, Text } from "@mantine/core";

interface SavingModalProps {
  opened: boolean;
  onClose: () => void;
  message?: string;
}

export const SavingModal = ({ opened, onClose, message }: SavingModalProps) => (
  <Modal
    opened={opened}
    onClose={onClose}
    withCloseButton={false}
    centered
    zIndex={3000}
    overlayProps={{ opacity: 0.3, blur: 2 }}
  >
    <Stack align="center" justify="center">
      <Loader />
      <Text fw={500} ta="center">
        {message || "Saving data..."}
        <br />
        Please do not close or refresh the screen.
      </Text>
    </Stack>
  </Modal>
);
